module.exports = __webpack_public_path__ + "static/media/nami.2ef7017e.png";